{
  "appName": "sign-in-health-portal",
  "entryFile": "./app-entry.jsx",
  "entryName": "sign-in-health-portal",
  "rootUrl": "/sign-in-health-portal",
  "productId": "9f231c06-f144-4aba-b572-7639b291cbaa"
}
